import React, { useEffect, useState } from "react";
import OrderTable from "./OrderTable";
import AddOrderModal from "./modals/AddOrderModal";
import { OrderProvider, useOrder } from "../contexts/order";
import classNames from "classnames";
import BarcodeForm from "./modals/BarcodeForm";
import OrderColorForm from "./modals/OrderColorForm ";
import OrderPaperForm from "./modals/PaperOredrForm";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/auth";
import { OrderName } from "../enums";
import { useFormik } from "formik";
import { ErrorBoundary } from "react-error-boundary";
import FallbackComponent from "./fallbackRenders/FallbackComponent";
import ModalAddCore from "./orderPage/dataModals/ModalAddCore";
import ModalAddPaperSize from "./orderPage/dataModals/ModalAddPaperSize";
import ModalAddPaperType from "./orderPage/dataModals/ModalAddPaperType";
import ModalAddLabelSize from "./orderPage/dataModals/ModalAddLabelSize";
import ModalAddUp from "./orderPage/dataModals/ModalAddUp";
import Cookies from "js-cookie";

export default function OrderPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="p-4 h-full overflow-auto">
      <OrderProvider>
        <ErrorBoundary fallbackRender={FallbackComponent}>
          <OrderHeader setIsModalOpen={setIsModalOpen} />
        </ErrorBoundary>
        <AddOrderModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
        <BarcodeForm />
        {/* models from data page */}
        <ModalAddCore />
        <ModalAddPaperSize />
        <ModalAddPaperType />
        <OrderColorForm />
        <ModalAddLabelSize />
        <ModalAddUp />

        <ErrorBoundary fallbackRender={FallbackComponent}>
          <OrderTable />
        </ErrorBoundary>
        <OrderPaperForm />
        <ErrorBoundary fallbackRender={FallbackComponent}>
          <Pagination />
        </ErrorBoundary>
      </OrderProvider>
    </div>
  );
}

const validate = (values) => {
  const errors = {};
  return errors;
};

const OrderHeader = ({ setIsModalOpen }) => {
  const [{ isHistoryPage, orderdata }] = useOrder();
  const [{ activeUser, isEditor }] = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const payload = JSON.stringify({
    brand_name: searchParams.get("brand_name"),
    party_name: searchParams.get("party_name"),
    order_type: searchParams.get("order_type"),
    size: searchParams.get("size"),
    teeth: searchParams.get("teeth"),
  });

  useEffect(() => {
    const data = JSON.parse(payload);
    formik.setFieldValue("brand_name", data.brand_name ?? "");
    formik.setFieldValue("party_name", data.party_name ?? "");
    formik.setFieldValue("order_type", data.order_type ?? "");
    formik.setFieldValue("size", data.size ?? "");
    formik.setFieldValue("teeth", data.teeth ?? "");
  }, [payload]);

  async function submitFormData(values) {
    navigate(
      (isHistoryPage ? "/history-filter/1" : "/order-filter/1") +
        `?brand_name=${values?.brand_name}&party_name=${values?.party_name}&order_type=${values?.order_type}&size=${values?.size}&teeth=${values?.teeth}&paper_type=${values.paper_type}`
    );
  }

  function handleReset() {
    formik.resetForm({
      brand_name: "",
      party_name: "",
      order_type: "",
      size: "",
      teeth: "",
      paper_type: "",
    });
    navigate(isHistoryPage ? "/history/1" : "/order/1");
  }

  const formik = useFormik({
    initialValues: {
      brand_name: "",
      party_name: "",
      order_type: "",
      size: "",
      teeth: "",
      paper_type: "",
    },
    validate,
    onSubmit: (values, actions) => {
      submitFormData(values, actions, activeUser);
    },
  });

  return (
    <div>
      {!isHistoryPage && isEditor && (
        <>
          <div className="flex">
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-orange text-white p-2 rounded-md mb-4"
            >
              Add Order
            </button>
          </div>
        </>
      )}

      <form
        className="p-4 rounded-t-md bg-orange flex flex-wrap items-center gap-3"
        onSubmit={formik.handleSubmit}
      >
        <span className="text-white">Search:</span>
        <input
          className="rounded-sm py-1 px-2"
          value={formik.values.party_name}
          onChange={formik.handleChange}
          type="text"
          name="party_name"
          placeholder="Search Party Name"
        />
        <input
          className="rounded-sm py-1 px-2"
          value={formik.values.brand_name}
          onChange={formik.handleChange}
          type="text"
          name="brand_name"
          placeholder="Search Brand Name"
        />

        <input
          className="rounded-sm py-1 px-2"
          type="text"
          name="paper_type"
          value={formik.values.paper_type}
          onChange={formik.handleChange}
          placeholder="Search Paper Type"
        />

        <input
          className="rounded-sm py-1 px-2"
          value={formik.values.size}
          onChange={formik.handleChange}
          type="text"
          name="size"
          placeholder="Search Size"
        />

        <select
          name="teeth"
          value={formik.values.teeth}
          onChange={formik.handleChange}
          className="rounded-sm py-1 px-2"
        >
          <option value="">select Teeth</option>
          {orderdata?.teeths?.map(({ teeth }, i) => (
            <option key={i} value={teeth || ""}>
              {teeth || "-"}
            </option>
          ))}
        </select>

        <select
          name="order_type"
          value={formik.values.order_type}
          onChange={formik.handleChange}
          className="rounded-sm py-1 px-2"
        >
          <option value="">select order</option>
          {OrderName?.map((name, i) => (
            <option key={i} value={i}>
              {name}
            </option>
          ))}
        </select>

        <button className="bg-white rounded-sm px-2 py-1" type="submit">
          Submit
        </button>
        <button
          onClick={handleReset}
          className="bg-white rounded-sm px-2 py-1"
          type="button"
        >
          Reset
        </button>
      </form>
    </div>
  );
};

const Pagination = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [{ orders, isHistoryPage, isFilterPage, limit }, { setLimit }] =
    useOrder();
  const currentPage = orders?.current_page;

  const party_name = searchParams.get("party_name");
  const brand_name = searchParams.get("brand_name");
  const order_type = searchParams.get("order_type");
  const size = searchParams.get("size");
  const teeth = searchParams.get("teeth");

  function fetchOrderData(page) {
    if (isFilterPage) {
      navigate(
        (isHistoryPage ? "/history-filter/" : "/order-filter/") +
          page +
          `?brand_name=${brand_name}&party_name=${party_name}&order_type=${order_type}&size=${size}&teeth=${teeth}`
      );
    } else {
      navigate((isHistoryPage ? "/history/" : "/order/") + page);
    }
  }

  function handleChange(e) {
    setLimit(e.target.value);
    Cookies.set("limit", e.target.value, {
      expires: 100,
      path: "/",
      secure: false,
      sameSite: "Lax",
    });
  }

  if (!orders) return null;
  return (
    <div className="mt-6">
      <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-4 sm:px-6">
        <div className="flex flex-1 items-center justify-between">
          <div className="flex gap-2 items-center">
            <select
              className="p-1 border rounded-lg"
              onChange={handleChange}
              name=""
              id=""
              defaultValue={limit}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <div>
              <p className="text-sm text-gray-700">
                Showing <span className="font-medium">{orders.from}</span> to
                <span className="font-medium">{orders.to}</span> of
                <span className="font-medium">{orders.total}</span> results
              </p>
            </div>
          </div>
          <div>
            <nav
              className="isolate inline-flex -space-x-px rounded-md shadow-sm"
              aria-label="Pagination"
            >
              {orders.links.map(({ active, label, url }, i) => {
                return (
                  <button
                    key={url ? url + label : i}
                    disabled={!url}
                    onClick={() =>
                      fetchOrderData(
                        i === 0
                          ? currentPage - 1
                          : i === orders.links.length - 1
                          ? currentPage + 1
                          : label
                      )
                    }
                    className={classNames(
                      "border px-2 py-1",
                      active && "bg-orange text-white"
                    )}
                  >
                    {i === 0
                      ? "<"
                      : i === orders.links.length - 1
                      ? ">"
                      : label}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};
